import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import * as toastr from 'toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import FormHeader from '../../component/dccore-form/formHeader.vue'
import { MEMBER_GET_MEMBER_CODE_TYPES } from '../../const/common.js'
import Checkbox from '../../component/dccore-form/checkbox.vue'

const id = '#membergetmember_form'
if ($(id).length) {
  Vue.use(VueResource)
  new Vue({
    el: id,
    components: {
      RingLoader,
      Singleselect,
      TextInput,
      FormHeader,
      NumberInput,
      Checkbox,
    },
    mixins: [mixins],
    data: {
      errors: {},
      memberGetMemberId : null,
      loading: 0,
      form: {
        brand: null,
        entity: {
          brand: null,
          codeType: 'member_get_member',
          promoCode: null,
          isActive: false,
        },
        options: {
          brand: [],
        },
      },
      codeTypes: MEMBER_GET_MEMBER_CODE_TYPES,
      selectedCodeTypes: 'member_get_member',
      disabledMemberToMember: true,
      disabledCodeTypes: false,
      disabledBrands: false,
    },
    computed: {
      visibleMemberToMember: function () {
        return (this.selectedCodeTypes === 'promo_code')
      },
    },
    watch:{
      'selectedCodeTypes' : function(codeType) {
        this.errors = {}
        this.form.entity.codeType = codeType
      }
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.memberGetMemberId = $('#entity_id').val()
        this.getMemberGetMember()
      } else {
        this.getBrands()
      }

      this.form.entity.promoCode = this.generateCode()
    },
    methods: {
      createMemberGetMember: function (redirect) {
        this.errors = {}
        var url = Routing.generate('api_post_member_get_member')

        Vue.http.post(url, this.getParametersRequestByCodeType(this.form.entity.codeType)).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('member_get_member_grid'))
          } else {
            toastr.success(Translator.trans('member_get_member.create.created'))
          }
        }, response => {
          this.handleAjaxError(response)
        })
      },
      updateMemberGetMember: function (redirect) {
        this.loading++
        var url = Routing.generate('api_patch_member_get_member', { id: this.memberGetMemberId })

        Vue.http.patch(url, {
          'data': this.getParametersRequestByCodeType(this.form.entity.codeType),
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('member_get_member_grid'))
          } else {
            this.errors = {}
            toastr.success(Translator.trans('member_get_member.update.updated'))
          }
        }, response => {
          this.handleAjaxError(response)
        }).finally(() => {
          this.loading--
        })
      },
      getBrands() {
        let url = `${Routing.generate('api_get_brands', { context: 'dropdown' })}`
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.brand = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getMemberGetMember: function () {
        this.disabledBrands = true
        this.disabledCodeTypes = true

        var url = Routing.generate('api_get_member_get_member', { id: this.memberGetMemberId,
          context: 'edit' })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.entity = response.data
          this.form.brand = this.form.entity.brand.id
          this.selectedCodeTypes = this.form.entity.codeType
          this.getBrands()
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      generateCode: function () {
        const length = 11
        const charset = 'abcdefghijklmnopqrstuvwxyz0123456789'
        let retVal = ''

        for (let i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n))
        }

        return retVal
      },
      refreshPromoCode: function () {
        this.form.entity.promoCode = this.generateCode()
      },
      getParametersRequestByCodeType: function (codeType) {
        const codeTypes = {
          member_get_member: {
            brand: this.form.entity.brand,
            codeType: this.form.entity.codeType,
            spendExpirePeriod: this.form.entity.spendExpirePeriod,
            spendPeriod: this.form.entity.spendPeriod,
            spendThreshold: this.form.entity.spendThreshold,
            spendValue: this.form.entity.spendValue,
            registerExpirePeriod: this.form.entity.registerExpirePeriod,
            registerRemindPeriod: this.form.entity.registerRemindPeriod,
            registerValue: this.form.entity.registerValue,
            referredClientFirstOrderValue: this.form.entity.referredClientFirstOrderValue,
          },
          promo_code: {
            brand: this.form.entity.brand,
            codeType: this.form.entity.codeType,
            promoCode: this.form.entity.promoCode,
            registerExpirePeriod: this.form.entity.registerExpirePeriod,
            registerRemindPeriod: this.form.entity.registerRemindPeriod,
            registerValue: this.form.entity.registerValue,
            isActive: this.form.entity.isActive,
          }
        }

        return codeTypes[codeType]
      }
    }
  })
}
